// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --kr-mobile-width: 960px;
  --kr-tablet-width: 1200px;
  --ui-grid-breakpoint: 768px;
  --kr-max-content-width: 1156px;
}

.kb-labfront.container .list-sort-options {
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin: 0 auto 55px auto;
  text-align: center;
  width: 350px;
}
@media (max-width: 960px) {
  .kb-labfront.container .list-sort-options {
    width: auto;
  }
}
.kb-labfront.container .list-sort-options > .ui.selection.dropdown {
  height: 45px;
  flex: 1 1 auto;
}
.kb-labfront.container .list-sort-options > .ui.selection.dropdown > .text {
  font-weight: 300;
  line-height: 17px;
}
.kb-labfront.container .list-sort-options > .sort {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  width: 45px;
  border-radius: 0.2857142857rem;
  box-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset;
  cursor: pointer;
}
.kb-labfront.container .list-sort-options > .sort .icon {
  height: auto;
  flex: 0 0 45px;
}
.kb-labfront.container .list-sort-options > .sort .icon.up svg {
  transform-box: fill-box;
  transform-origin: 50% 50%;
  transform: scaleY(-1);
}
.kb-labfront.container .list-sort-options.light-blue-theme > .sort {
  top: 1px;
  box-shadow: 0 0 0 0.1em rgba(255, 255, 255, 0.4) inset;
}`, "",{"version":3,"sources":["webpack://./src/styling/_kr.scss","webpack://./src/components/pageElements/ListSortOptions/ListSortOptions.scss"],"names":[],"mappings":"AAiBA;EACE,wBAAA;EACA,yBAAA;EACA,2BAAA;EACA,8BAAA;AChBF;;AAHE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;AAMJ;AALI;EAPF;IAQI,WAAA;EAQJ;AACF;AAPI;EACE,YAAA;EACA,cAAA;AASN;AARM;EACE,gBAAA;EACA,iBAAA;AAUR;AAPI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,gDAAA;EACA,eAAA;AASN;AARM;EACE,YAAA;EACA,cAAA;AAUR;AARU;EACE,uBAAA;EACA,yBAAA;EACA,qBAAA;AAUZ;AALI;EACE,QAAA;EACA,sDAAA;AAON","sourcesContent":["@forward 'kr_colors';\n@forward 'semantic_ui_overrides';\n@forward 'labrador_overrides';\n\n// Maximum page size\n$max_content_width: 1156px;\n\n// Minimum left/right padding\n$min_content_gutter: 22px;\n\n// Minimum left/right padding\n$ui-grid-breakpoint: 768px;\n\n// Breakpoints\n$mobile_width: 960px;\n$tablet_width: $max_content_width + ( 2 * $min_content_gutter ); // 1200 px\n\n:root {\n  --kr-mobile-width: #{$mobile-width};\n  --kr-tablet-width: #{$tablet-width};\n  --ui-grid-breakpoint: #{$ui-grid-breakpoint};\n  --kr-max-content-width: #{$max_content_width};\n}\n\n@mixin max-page-dim {\n  position: relative;\n  max-width: $max_content_width;\n  margin: 0 auto;\n  @media ( max-width: $tablet-width ) {\n    padding-left: $min_content_gutter;\n    padding-right: $min_content_gutter;\n    &.no-gutter {\n      padding-left: 0;\n      padding-right: 0;\n      @media ( min-width: 748px ) and ( max-width: ( $max_content_width + ( $min_content_gutter * 2 ) ) ) {\n        padding-left: $min_content_gutter;\n        padding-right: $min_content_gutter;\n      }\n    }\n  }\n}\n","@use '/src/styling/kr';\n.kb-labfront.container {\n  .list-sort-options {\n    display: flex;\n    flex-direction: row;\n    gap: 5px;\n    margin: 0 auto 55px auto;\n    text-align: center;\n    width: 350px;\n    @media ( max-width: kr.$mobile-width ) {\n      width: auto;\n    }\n    & > .ui.selection.dropdown {\n      height: 45px;\n      flex: 1 1 auto;\n      & > .text {\n        font-weight: 300;\n        line-height: 17px;\n      }\n    }\n    & > .sort {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 45px;\n      width: 45px;\n      border-radius: 0.2857142857rem;\n      box-shadow: 0 0 0 0.1em rgba(0, 0, 0, 0.1) inset;\n      cursor: pointer;\n      .icon {\n        height: auto;\n        flex: 0 0 45px;\n        &.up {\n          svg {\n            transform-box: fill-box;\n            transform-origin: 50% 50%;\n            transform: scaleY(-1);\n          }\n        }\n      }\n    }\n    &.light-blue-theme > .sort {\n      top: 1px;\n      box-shadow: 0 0 0 0.1em rgba(255, 255, 255, 0.4) inset;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
